import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { MyAccountDashboardPageInitialData } from "./myAccountDashboardPageInitialData";

export const myAccountDashboardPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.myAccount(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<MyAccountDashboardPageInitialData>>("/page-data/my-account"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
